import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';

import { UserFormService } from '../user-form/user-form.service';

@Component({
    selector: 'user-button',
    templateUrl: './user-button.component.html',
    styles: ['.button-disabled { opacity: 0.2; } :host { display: block; }']
})
export class UserButtonComponent {

    @Input() disabled: boolean = false;
    @Output('click') click: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input('ignore-validity') ignoreValidity: boolean = false;

    constructor(public service: UserFormService) {
    }

    doClick(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();

        if (this.ignoreValidity && this.disabled)
            return;

        if (this.ignoreValidity || (this.service && !this.service.isInvalid)) {
            this.click.emit(true);
        }
        else if (this.service) {
            this.service.setAsTouched.emit();
        }
    }
    
}
